<div class="left">
  <div class="container">
    <div class="left-in">
      <div class="logo">
        <img (click)="redirect()" src="../../../assets/img/logo.svg" alt="">
      </div>
      <div class="data">
        <p>
          მზად ხარ თავგადასავლებისთვის
        </p>
        <h5>
          სამოგზაურო
          <br>
           დაზღვევა
        </h5>
      </div>
    </div>
  </div>
</div>
